import {
  BookingFollowUp,
  BookingFollowUpStatus,
  BookingFollowUpType,
  Employee,
} from "../../process/types/processTypes";

export const FOLLOW_UP_STATUS_ORDER: BookingFollowUpStatus[] = [
  BookingFollowUpStatus.new,
  BookingFollowUpStatus.booked_with_date,
  BookingFollowUpStatus.confirmed_by_employee,
  BookingFollowUpStatus.employee_completed,
];

export function followUpFieldForType(
  type: BookingFollowUpType,
): "medicalFollowUp" | "tasheerFollowUp" | "flightFollowUp" {
  switch (type) {
    case BookingFollowUpType.medical:
      return "medicalFollowUp";
    case BookingFollowUpType.tasheer:
      return "tasheerFollowUp";
    case BookingFollowUpType.flight:
      return "flightFollowUp";
  }
}

export function getFollowUpForType(
  employee: Employee,
  type: BookingFollowUpType,
): BookingFollowUp | undefined {
  return employee[followUpFieldForType(type)];
}

export function effectiveFollowUpStatus(
  followUp?: BookingFollowUp | null,
): BookingFollowUpStatus {
  return followUp?.status ?? BookingFollowUpStatus.new;
}

export function nextFollowUpStatus(
  current: BookingFollowUpStatus,
): BookingFollowUpStatus | null {
  const idx = FOLLOW_UP_STATUS_ORDER.indexOf(current);
  if (idx < 0 || idx >= FOLLOW_UP_STATUS_ORDER.length - 1) return null;
  return FOLLOW_UP_STATUS_ORDER[idx + 1];
}

export function isForwardFollowUpTransition(
  from: BookingFollowUpStatus,
  to: BookingFollowUpStatus,
): boolean {
  const fromIdx = FOLLOW_UP_STATUS_ORDER.indexOf(from);
  const toIdx = FOLLOW_UP_STATUS_ORDER.indexOf(to);
  if (fromIdx < 0 || toIdx < 0) return false;
  return toIdx >= fromIdx;
}

/** Returns the reason a target status cannot be applied, or `null` if eligible. */
export function ineligibleFollowUpReason(
  targetStatus: BookingFollowUpStatus,
  employee: Employee,
  type: BookingFollowUpType,
): string | null {
  const current = effectiveFollowUpStatus(getFollowUpForType(employee, type));
  if (!isForwardFollowUpTransition(current, targetStatus)) {
    return "status cannot move backwards";
  }
  return null;
}

export function countForFollowUpType(
  counts:
    | { type: BookingFollowUpType; byStatus: { status: string; count: number }[] }[]
    | undefined,
  type: BookingFollowUpType,
  status?: BookingFollowUpStatus,
): number {
  const row = counts?.find((c) => c.type === type);
  if (!row) return 0;
  if (!status) {
    return row.byStatus
      .filter(
        (s) => s.status !== BookingFollowUpStatus.employee_completed,
      )
      .reduce((sum, s) => sum + s.count, 0);
  }
  return row.byStatus.find((s) => s.status === status)?.count ?? 0;
}

export const WAFID_BOOKING_URL = "https://www.wafid.com/book-appointment/";
export const TASHEER_URL = "https://agents.tasheer.com/";
